import * as action_types from "./constants";
import { UserType } from "./types";

export type myProfileState = {
  userData: {
    loader: boolean;
    data: UserType | null;
  };
};

const initialState: myProfileState = {
  userData: {
    loader: true,
    data: null,
  },
};

const myProfileReducer = (
  state = initialState,
  action: { type: string; payload: { data: UserType | null } }
) => {
  const { type, payload } = action;
  switch (type) {
    case action_types.USER_DETAILS:
      return { ...state, userData: { loader: false, data: payload?.data } };

    default:
      return state;
  }
};

export default myProfileReducer;
